import { useRoute } from "vue-router";
import { QueryStringDataBuilder } from "@/core/QueryString/QueryStringDataBuilder";
// import { BlobConfigDataBuilder } from "../../service/blobConfig/BlobConfigDataBuilder";
import ConfigManager from "@/config/ConfigManager";
import BzbsApiLegacy from "@/core/Http/BzbsApiLegacy"
import Util from "@/helper/Utility";
// import BlobService from "@/core/Blob/service/BlobService";

export default function (states) {
    const route = useRoute()

    /**
     *
     * @returns {Promise}
     */
    const loadConfig = function () {
        // load config from url query string
        let queryString = new QueryStringDataBuilder()
        states.query = queryString.setWithQuery(route.query).create();
        console.log(route.query)

        if (states.query.theme) {
            states.blobUrl = `${ConfigManager.getBlobUrl()}/config/transferpoint/${states.mainAppName}/${states.query.theme}`;
        }

        return Promise.all([getBlobApiConfig()]).then((results) => {
            return results
        })
    }

    const getBlobApiConfig = function () {
        return new Promise((resolve, reject) => {
            BzbsApiLegacy.getBlobAppThemeMapping().then((app_mapping) => {
                let app_id = Util.getAppIdFromTheme(app_mapping, states.query.theme);
                console.log(app_id)

                // get landing blob config
                BzbsApiLegacy.getBlobWeblandingConfig(app_id).then((res_config) => {
                    states.blobWebLanding = res_config
                    resolve(states.blobWebLanding)
                    // console.log(states.blobWebLanding)
                }).catch((err) => {
                    console.log(err)
                    states.blobWebLanding = null
                    reject(err)
                });
            }).catch((err) => {
                console.log(err)
                states.blobWebLanding = null
                reject(err)
            });
        })
                // // theme mapping
                // return new Promise((resolve, reject) => {
                //     let app_id = "template_apiservice";
                //         console.log(app_id)

                //     // get landing blob config
                //     BzbsApiLegacy.getBlobWeblandingConfig().then((res_config) => {
                //         states.blobWebLanding = res_config
                //         resolve(states.blobWebLanding)
                //         // console.log(states.blobWebLanding)
                //     }).catch((err) => {
                //         console.log(err)
                //         states.blobWebLanding = null
                //         reject(err)
                //     });
                // })
    }

    return {
        loadConfig,
        getBlobApiConfig
    }
}
